import bem from 'utils/bem';

export const block = bem('paused-subscription-info');

export const DATE_FORMAT = 'MM.DD.YYYY';
